import { Button, Card, Field, Heading } from '@components'
import type { Profile } from '@here/api'
import { createForm, setValues, valiForm } from '@modular-forms/solid'
import { useAuth } from '@state'
import { createEffect, on } from 'solid-js'
import { useService } from 'solid-services'
import { grid } from 'styled-system/patterns'
import * as v from 'valibot'
import { useProfile } from '../state'

export const ProfileSchema = v.object({
	id: v.string(),
	username: v.pipe(
		v.string(),
		v.minLength(1, 'Username must be defined'),
		v.regex(
			/^(?:[a-zA-Z]+(?: [a-zA-Z]{1,2})?)$/,
			'Username must be a single word or a word followed by a space and a 1-2 letter suffix. eg, Francis, Francis H or Francis Hu',
		),
	),
})

export default function () {
	const { profile, refetchProfile, profilePrivate } = useService(useAuth)()
	const { setProfile, profileResource } = useService(useProfile)()
	const [form, { Form, Field: FormField }] = createForm<
		Pick<Profile, 'id' | 'username'>
	>({
		validate: valiForm(ProfileSchema),
		revalidateOn: 'change',
	})

	createEffect(
		on(profile, () => {
			if (profile()) {
				setValues(form, profile()!)
			}
		}),
	)

	createEffect(() => {
		if (profileResource.state === 'ready') {
			refetchProfile()
		}
	})

	return (
		<Card.Root
			p={4}
			class={grid({
				gridTemplateRows: 'auto 1fr',
			})}
		>
			<Heading>Profile</Heading>
			<Form
				onSubmit={setProfile}
				class={grid({
					alignContent: 'space-between',
				})}
			>
				<FormField name="username">
					{(field, formFieldProps) => (
						<Field.Root invalid={!!field.error}>
							<Field.Label>Username</Field.Label>
							<Field.Input
								{...formFieldProps}
								disabled={profileResource.loading}
								value={field.value ?? ''}
								type="text"
							/>
							<Field.ErrorText>
								{field.error && <div>{field.error}</div>}
							</Field.ErrorText>
						</Field.Root>
					)}
				</FormField>

				<Field.Root>
					<Field.Label>Rank</Field.Label>
					<Field.Input
						disabled
						value={profilePrivate()?.role ?? ''}
						type="text"
					/>
				</Field.Root>

				<FormField name="id">
					{(field, props) => (
						<Field.Input
							display="none"
							type="text"
							{...props}
						/>
					)}
				</FormField>

				<Button
					loading={profileResource.loading}
					type="submit"
					justifySelf="start"
					colorPalette="tscGreen"
					variant="solid"
				>
					Save
				</Button>
			</Form>
		</Card.Root>
	)
}
